import wootConstants from 'dashboard/constants/globals';
import ConversationApi from 'dashboard/api/inbox/conversation';

const { ASSIGNEE_TYPE, STATUS_TYPE } = wootConstants;

// The Omni inbox panel views. Each maps to the basic conversation-list query
// params (assignee_type / status / awaiting) that the ConversationFinder reads.
export const OMNI_VIEWS = {
  MY_INBOX: 'my_inbox',
  UNASSIGNED: 'unassigned',
  ALL: 'all',
  AWAITING_MY_REPLY: 'awaiting_my_reply',
  AWAITING_THEIR_REPLY: 'awaiting_their_reply',
  NO_ACTION_NEEDED: 'no_action_needed',
  DONE: 'done',
};

// view -> conversation-list query params.
//   status omitted  -> the list keeps its own status filter (defaults to open)
//   awaiting 'mine'  -> last message is incoming (waiting for the agent's reply)
//   awaiting 'theirs'-> last message is outgoing (waiting for the contact's reply)
export const OMNI_VIEW_QUERY = {
  [OMNI_VIEWS.MY_INBOX]: { assigneeType: ASSIGNEE_TYPE.ME },
  [OMNI_VIEWS.UNASSIGNED]: { assigneeType: ASSIGNEE_TYPE.UNASSIGNED },
  [OMNI_VIEWS.ALL]: { assigneeType: ASSIGNEE_TYPE.ALL },
  [OMNI_VIEWS.AWAITING_MY_REPLY]: {
    assigneeType: ASSIGNEE_TYPE.ME,
    status: STATUS_TYPE.ALL,
    awaiting: 'mine',
  },
  [OMNI_VIEWS.AWAITING_THEIR_REPLY]: {
    assigneeType: ASSIGNEE_TYPE.ME,
    status: STATUS_TYPE.ALL,
    awaiting: 'theirs',
  },
  // "No action needed" is intentionally empty for now (no conversations shown).
  [OMNI_VIEWS.NO_ACTION_NEEDED]: {
    assigneeType: ASSIGNEE_TYPE.ME,
    status: STATUS_TYPE.ALL,
    empty: true,
  },
  [OMNI_VIEWS.DONE]: {
    assigneeType: ASSIGNEE_TYPE.ME,
    status: STATUS_TYPE.RESOLVED,
  },
};

const state = {
  activeView: OMNI_VIEWS.MY_INBOX,
  priority: null,
  counts: { views: {}, priorities: {}, labels: {}, inboxes: {} },
};

export const getters = {
  getActiveView: $state => $state.activeView,
  getPriority: $state => $state.priority,
  getCounts: $state => $state.counts,
  getActiveViewQuery: $state =>
    OMNI_VIEW_QUERY[$state.activeView] || OMNI_VIEW_QUERY[OMNI_VIEWS.MY_INBOX],
};

export const actions = {
  // Selecting a view (folder) clears any active priority folder — they are
  // mutually exclusive (only one folder is active at a time).
  setActiveView({ commit }, view) {
    commit('SET_OMNI_ACTIVE_VIEW', view);
    commit('SET_OMNI_PRIORITY', null);
  },
  // Priority folders (urgent/high/medium/low) behave like views: selecting one
  // is the active folder until another folder is selected.
  setPriority({ commit }, priority) {
    commit('SET_OMNI_PRIORITY', priority);
  },
  async fetchCounts({ commit }) {
    try {
      const { data } = await ConversationApi.omniCounts();
      commit('SET_OMNI_COUNTS', data);
    } catch (error) {
      // Counts are best-effort; ignore failures.
    }
  },
};

export const mutations = {
  SET_OMNI_ACTIVE_VIEW($state, view) {
    $state.activeView = view;
  },
  SET_OMNI_PRIORITY($state, priority) {
    $state.priority = priority;
  },
  SET_OMNI_COUNTS($state, counts) {
    $state.counts = {
      views: counts?.views || {},
      priorities: counts?.priorities || {},
      labels: counts?.labels || {},
      inboxes: counts?.inboxes || {},
    };
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
